const Header = () => {
    return <header className="my-10">
        <h1 className="text-gray-500 font-thin text-center text-2xl">CRUD with Redux Toolkit</h1>
    </header>
};

export default Header;